import React, {Component} from "react";

type Props = {
	value: string,
	updateConfig: Function
}

type State = {
	label: string
}

class Label extends Component<Props, State>{
	private readonly originalLabel: string;
	constructor(props: Props) {
		super(props);
		this.originalLabel = this.props.value;
		this.state = {
			label: this.props.value || ""
		}
	}

	handleLabelChange(e: any) {
		const label = e.currentTarget.value;
		if (label === "") {
			this.setState({label: ""});
			this.props.updateConfig(['label'], [this.originalLabel]);
		} else {
			this.setState({label})
			this.props.updateConfig(['label'], [label]);
		}
	}

	render() {
		return (
			<div className="config-item__label">
				<div className="form-group">
					<label htmlFor="">Label name</label>
					<input
						type="text" className="form-control" value={this.state.label}
						onChange={(e) => this.handleLabelChange(e)}
						placeholder="Name of this component"
					/>
				</div>
			</div>
		);
	}
}

export default Label;
